import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';
import { ListItem, Collapse, TextField, FormControlLabel, RadioGroup, Radio, Tooltip } from '@material-ui/core';
import { ExpandLess, ExpandMore, ArrowBack } from '@material-ui/icons';
import { cloneDeep } from 'lodash';

import { getStaticText } from '../../utils/constants';
import CloseIcon from '../../assets/Close.svg';
import SearchIcon from '../../assets/Magnifying.svg';
import './index.scss';
import { getBenchmarkString } from '../../utils/functions';

function Benchmarks({
    showHeader,
    resetOnSelect,
    benchmarks,
    setBenchMark,
    setBackOldView,
    updateBenchmarks,
    getSelectedChild,
    defaultSettings,
    isInclusion,
    benchmarkVersions,
    isReportBm,
    apiParams,
    getMappedTargetSettingBm,
    isEEpage,
}) {
    const { lang, inclusion_resurvey_settings = '' } = defaultSettings;
    const staticText = getStaticText(lang);
    const { SITE_TEXT, FILTER_LIST_RANGE } = staticText;
    const { VIEW_ALL, BENCHMARK_HEAD, SEARCH, QUARTILE_MOVE, BM_DISABLE_TXT, EX_BENCHMARK } = SITE_TEXT || {};
    const isQuartileMovement = inclusion_resurvey_settings === QUARTILE_MOVE && isInclusion;
    const noIaBm = benchmarkVersions.toLowerCase().trim() === 'no benchmark';
    const handleChildCheck = ({ value }, indexParent) => {
        const newBenchmarks = cloneDeep(benchmarks);
        const selectedItemIndex = newBenchmarks.findIndex(({ selectedOption }) => selectedOption);
        if (selectedItemIndex !== -1 && selectedItemIndex !== indexParent) {
            newBenchmarks[selectedItemIndex].selectedOption = '';
        }
        newBenchmarks[indexParent].selectedOption = parseInt(value, 10);
        if (resetOnSelect) {
            newBenchmarks[indexParent].isOpen = false;
            newBenchmarks[indexParent].viewAll = false;
            newBenchmarks[indexParent].search = '';
        }
        setBenchMark(true);
        updateBenchmarks(newBenchmarks);
        getSelectedChild(newBenchmarks[indexParent]);
        if (isReportBm) {
            getMappedTargetSettingBm({ ...apiParams, benchmarks: getBenchmarkString(newBenchmarks) });
        }
    };

    const handleParentClick = index => {
        const newBenchmarks = cloneDeep(benchmarks);
        const openItem = newBenchmarks.findIndex(({ isOpen: oldOpen }) => oldOpen);
        if (openItem !== -1 && openItem !== index) {
            newBenchmarks[openItem].isOpen = false;
        }
        const { isOpen = false } = newBenchmarks[index];
        newBenchmarks[index].isOpen = !isOpen;
        newBenchmarks[index].viewAll = false;
        newBenchmarks[index].search = '';
        updateBenchmarks(newBenchmarks);
    };

    const selectOptions = ({ value }, index) => {
        const newBenchmarks = cloneDeep(benchmarks);
        newBenchmarks[index].search = value;
        updateBenchmarks(newBenchmarks);
    };

    const resetSearch = index => {
        const newBenchmarks = cloneDeep(benchmarks);
        newBenchmarks[index].search = '';
        updateBenchmarks(newBenchmarks);
    };

    const toggleView = index => {
        const newBenchmarks = cloneDeep(benchmarks);
        newBenchmarks[index].viewAll = true;
        updateBenchmarks(newBenchmarks);
    };

    return (
        <div className="filterContent clearfix">
            {showHeader && (
                <Fragment>
                    <h3 onClick={() => setBackOldView()}>
                        <ArrowBack />
                        {isEEpage ? EX_BENCHMARK : BENCHMARK_HEAD}
                    </h3>
                    <div className="surveyData">
                        {/* {isInclusion ? (
                            <div className="demographicDropdown">
                                {benchmarkVersions.length > 1 ? (
                                    <Select
                                        data-testid="demographicOptions"
                                        IconComponent={KeyboardArrowDownSharpIcon}
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={bmVersionInUse}
                                        displayEmpty
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            },
                                            transformOrigin: {
                                                vertical: 'top',
                                                horizontal: 'left',
                                            },
                                            getContentAnchorEl: null,
                                        }}
                                        onChange={({ target: { value: code } }) => {
                                            if (code) {
                                                setBenchMark(true);
                                                setBmVersionInUse(code);
                                            }
                                        }}
                                    >
                                        <MenuItem classes={{ root: 'demographicOptions' }} value="">
                                            <em>{SELECT_BM_VERSION}</em>
                                        </MenuItem>
                                        {benchmarkVersions.map(
                                            ({
                                                BenchmarkPreCalculationSubVersionId,
                                                BenchmarkPreCalculationSubVersionName,
                                                SurveyCount,
                                                RespondentCount,
                                            }) => {
                                                return (
                                                    <MenuItem
                                                        key={BenchmarkPreCalculationSubVersionId}
                                                        classes={{ root: 'demographicOptions' }}
                                                        className="benchmarkList"
                                                        value={BenchmarkPreCalculationSubVersionId}
                                                    >
                                                        <Fragment>
                                                            <span>
                                                                {NUMBER_TEXT} = {RespondentCount}
                                                            </span>
                                                            <span>
                                                                {NUMBER_CAP_SURVEY_TEXT} :{' '}
                                                                {SurveyCount.toLocaleString('en-US')}
                                                            </span>
                                                            <span>{BenchmarkPreCalculationSubVersionName}</span>
                                                        </Fragment>
                                                    </MenuItem>
                                                );
                                            }
                                        )}
                                    </Select>
                                ) : (
                                    <div>
                                        {benchmarkVersions.map(
                                            ({
                                                BenchmarkPreCalculationSubVersionName,
                                                SurveyCount,
                                                RespondentCount,
                                            }) => {
                                                return (
                                                    <div>
                                                        <span>
                                                            {NUMBER_TEXT} = {RespondentCount}
                                                        </span>
                                                        <span>
                                                            {NUMBER_CAP_SURVEY_TEXT} :{' '}
                                                            {SurveyCount.toLocaleString('en-US')}
                                                        </span>
                                                        <span>{BenchmarkPreCalculationSubVersionName}</span>
                                                    </div>
                                                );
                                            }
                                        )}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <Fragment>
                                <div className="filterBenchRes">
                                    <div className="filterRes">
                                        <div>{YEAR}:</div>
                                        <div>{year}</div>
                                    </div>
                                    <div className="filterRes">
                                        <div>{NUMBER_TEXT} :</div>
                                        <div>{surveyRespondents.toLocaleString('en-US')}</div>
                                    </div>
                                    <div className="filterRes">
                                        <div>{NUMBER_CAP_SURVEY_TEXT} :</div>
                                        <div>{surveys.toLocaleString('en-US')}</div>
                                    </div>
                                </div>
                            </Fragment>
                        )} */}
                        {isInclusion ? (
                            <div>
                                <div>
                                    <span>{benchmarkVersions}</span>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </Fragment>
            )}
            <div className="upperContent clearfix">
                {benchmarks.map(
                    (
                        {
                            code = '',
                            label = '',
                            options = [],
                            isOpen = false,
                            viewAll = false,
                            search = '',
                            selectedOption = '',
                        },
                        indexParent
                    ) => {
                        const optionsLength = options.length;
                        const iconExpand =
                            options.length && !isInclusion ? (
                                <span className="expandIcon">{isOpen ? <ExpandLess /> : <ExpandMore />}</span>
                            ) : null;
                        const selectedOptions = search.trim()
                            ? options.filter(({ label: l = '' }) => `${l}`.toLowerCase().includes(search.toLowerCase()))
                            : options;

                        const optionsToUse = viewAll ? selectedOptions : selectedOptions.slice(0, FILTER_LIST_RANGE);
                        const { label: textToShow = '' } =
                            options.filter(({ code: childCod = '' }) => childCod === selectedOption)[0] || [];
                        const isDisabled =
                            (isQuartileMovement && code === -1) || (noIaBm && code === 11) || (!noIaBm && code === -1);
                        return (
                            <div className="mainListWrap benchMarckList" key={code}>
                                <Tooltip title={isDisabled ? BM_DISABLE_TXT : ''}>
                                    <ListItem
                                        classes={{ root: c('mainListContent', { borderBottom: !isOpen }) }}
                                        onClick={() => handleParentClick(indexParent)}
                                        data-testid={label}
                                        disabled={isDisabled}
                                    >
                                        {/* {optionsLength === 1 && (
                                            <Radio
                                                checked={!!selectedOption}
                                                value={options[0].code}
                                                onChange={() =>
                                                    handleChildCheck({ value: options[0].code }, indexParent)
                                                }
                                            />
                                        )} */}
                                        {label}
                                        {textToShow && <span className="textToShow">{textToShow}</span>}
                                        {iconExpand}
                                    </ListItem>
                                </Tooltip>
                                <Collapse
                                    in={isOpen && !isInclusion}
                                    timeout="auto"
                                    unmountOnExit
                                    classes={{ container: 'childWrapper' }}
                                >
                                    {optionsLength > 1 ? (
                                        <div className="searchHead">
                                            <img src={SearchIcon} alt="" className="searchIcon" />
                                            <TextField
                                                fullWidth
                                                value={search}
                                                placeholder={SEARCH}
                                                inputProps={{
                                                    'data-testid': `Text${label}`,
                                                }}
                                                onChange={({ target }) => selectOptions(target, indexParent)}
                                            />
                                            <img
                                                src={CloseIcon}
                                                alt=""
                                                className="closeIcon"
                                                onClick={() => resetSearch(indexParent)}
                                                data-testid={`Close${label}`}
                                            />
                                        </div>
                                    ) : null}

                                    <div className={c('optionList')}>
                                        <RadioGroup
                                            aria-label={label}
                                            name={label}
                                            value={selectedOption}
                                            onChange={({ target }) => handleChildCheck(target, indexParent)}
                                        >
                                            {optionsToUse.map(({ label: childLabel = '', code: childCode = '' }) => (
                                                <FormControlLabel
                                                    classes={{
                                                        root: c('optionItem'),
                                                    }}
                                                    value={childCode}
                                                    control={<Radio />}
                                                    label={childLabel}
                                                    key={childCode}
                                                    data-testid={childLabel}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </div>
                                    {!viewAll && selectedOptions.length > FILTER_LIST_RANGE ? (
                                        <div onClick={() => toggleView(indexParent)} className="viewAll">
                                            {VIEW_ALL}
                                        </div>
                                    ) : null}
                                </Collapse>
                            </div>
                        );
                    }
                )}
            </div>
        </div>
    );
}

Benchmarks.defaultProps = {
    showHeader: true,
    resetOnSelect: false,
    setBenchMark: () => {},
    setBackOldView: () => {},
    getSelectedChild: () => {},
    isInclusion: false,
    benchmarkVersions: '',
    isReportBm: false,
    getMappedTargetSettingBm: () => {},
    apiParams: {},
    isEEpage: false,
};

Benchmarks.propTypes = {
    showHeader: PropTypes.bool,
    resetOnSelect: PropTypes.bool,
    setBenchMark: PropTypes.func,
    setBackOldView: PropTypes.func,
    getSelectedChild: PropTypes.func,
    benchmarks: PropTypes.array.isRequired,
    updateBenchmarks: PropTypes.func.isRequired,
    defaultSettings: PropTypes.object.isRequired,
    isInclusion: PropTypes.bool,
    benchmarkVersions: PropTypes.string,
    getMappedTargetSettingBm: PropTypes.func,
    isReportBm: PropTypes.bool,
    apiParams: PropTypes.object,
    isEEpage: PropTypes.bool,
};

export default Benchmarks;
